import { css } from '@emotion/react';

import { colors } from '../../global';

export const ButtonPrimary = css`
    color: ${colors.white};
    background: ${colors.turquoiseGreenGradient};
`;
